import {AnyEvent, JOB_FILE_UPLOAD_STARTED, JobFileUploadStartedEvent} from '../type';

export default function jobFileUploadStarted(payload: JobFileUploadStartedEvent['payload']): AnyEvent {
  return {
    type: JOB_FILE_UPLOAD_STARTED,
    payload,
  }
}